import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AreaField, Panel, TextField } from "@/components/studio/Fields";
import { errorMessage } from "@/lib/api";
import { setStudioPassword, setStudioToken } from "@/lib/site";

export const SettingsPanel = ({ draft, set }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async () => {
    if (next.length < 10) {
      toast.error("Dix caractères minimum.");
      return;
    }
    setBusy(true);
    try {
      const { token } = await setStudioPassword(current, next);
      // the new password invalidates the token that was issued under the old
      // one, so the fresh token has to replace it here or the next call fails
      setStudioToken(token);
      setCurrent("");
      setNext("");
      toast.success("Mot de passe changé");
    } catch (error) {
      toast.error(errorMessage(error, "Changement impossible"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6">
      <Panel
        title="Service d’analytique"
        hint="Le compteur intégré fonctionne déjà et ne dépend de personne. Le jour où vous choisissez un service — Plausible, Umami ou autre — collez ici le script qu’il vous donne : il sera ajouté à chaque page."
      >
        <TextField
          label="Nom du service"
          hint="Pour mémoire."
          value={draft.analytics?.provider}
          onChange={(value) => set("analytics.provider", value)}
          placeholder="Plausible"
          testId="analytics-provider"
        />
        <AreaField
          label="Script à insérer"
          hint="Tel que le service vous le donne. Vérifiez qu’il ne dépose pas de cookie : sinon il faudra un bandeau de consentement, que le site n’a pas."
          value={draft.analytics?.snippet}
          onChange={(value) => set("analytics.snippet", value)}
          rows={4}
          testId="analytics-snippet"
        />
      </Panel>

      <Panel
        title="Mot de passe du studio"
        hint="Celui-ci n’ouvre que cet espace. Les mots de passe des mariages sont séparés : en changer un ici ne touche à aucun d’eux."
      >
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="mt-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[color:var(--muted-ink)]">
              Mot de passe actuel
            </p>
            <Input
              type="password"
              value={current}
              onChange={(event) => setCurrent(event.target.value)}
              autoComplete="current-password"
              data-testid="studio-current-password"
              className="mt-1.5 h-10 text-[13.5px]"
            />
          </div>
          <div className="mt-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-[color:var(--muted-ink)]">
              Nouveau mot de passe
            </p>
            <Input
              type="password"
              value={next}
              onChange={(event) => setNext(event.target.value)}
              autoComplete="new-password"
              data-testid="studio-new-password"
              className="mt-1.5 h-10 text-[13.5px]"
            />
          </div>
        </div>
        <Button onClick={change} disabled={busy} className="mt-5" data-testid="change-studio-password">
          Changer le mot de passe
        </Button>
      </Panel>
    </div>
  );
};

export default SettingsPanel;
